import billingModule from '../../billing.module';
import template from './billingOverview.component.html';

export default billingModule.component('billingOverview', {
    template
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-overview/billingOverview.component.js